import * as React from 'react';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import List from '@mui/material/List';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import Badge from '@mui/material/Badge';
import Container from '@mui/material/Container';
import MenuIcon from '@mui/icons-material/Menu';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import NotificationsIcon from '@mui/icons-material/Notifications';
import Copyright from '../../components/Copyright';
import AppBar from './AppBar';
import Drawer from './Drawer';
import { Outlet } from 'react-router-dom';
import { Avatar } from '@mui/material';
import intl from 'react-intl-universal';
import DashboardMenuList from './DashboardMenuList';

const drawerWidth = 240;

export default function Dashboard({ isOpen, mainMenuItems, secondaryMenuItems }) {

  const [open, setOpen] = React.useState(isOpen);
  function toggleDrawer(){
    setOpen(!open);
  };

  return (
    <Box sx={{ display: 'flex', width: '100%', }}>
      <AppBar position="absolute" open={open} width={drawerWidth}>
        <Toolbar
          sx={{
            pr: '24px', // keep right padding when drawer closed
          }}
        >
          <IconButton
            edge="start"
            color="inherit"
            aria-label="open drawer"
            onClick={toggleDrawer}
            sx={{
              marginRight: '36px',
              ...(open && { display: 'none' }),
            }}
          >
            <MenuIcon />
          </IconButton>
          <Typography
            component="h1"
            variant="h6"
            color="inherit"
            noWrap
            sx={{ flexGrow: 1 }}
          >
            {intl.get("mydashboard").d("My Dashboard")}
          </Typography>
          <IconButton color="inherit">
            <Badge 
              overlap="circular"
              anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
              badgeContent={4} color="primary">
              <Avatar sx={{ width: 24, height: 24, m: 1, bgcolor: 'primary.main' }}> 
                <NotificationsIcon />
              </Avatar>
            </Badge>
          </IconButton>
        </Toolbar>
      </AppBar>

      <Drawer variant="permanent" open={open} drawerWidth={drawerWidth}>
        <Toolbar
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-end',
            px: [1],
          }}
        >
          <IconButton onClick={toggleDrawer}>
            <ChevronLeftIcon />
          </IconButton>
        </Toolbar>
        <Divider />
        <List component="nav">
          <DashboardMenuList menuItems={mainMenuItems} />
          <Divider sx={{ my: 1 }} />
          {secondaryMenuItems}
        </List>
      </Drawer>

      <Box
        component="main"
        sx={{
          backgroundColor: (theme) =>
            theme.palette.mode === 'light'
              ? theme.palette.grey[100]
              : theme.palette.grey[900],
          flexGrow: 1,
          height: '100vh',
          width: '100%',
        }}
      >
        {/* This extra toolbar prevents the App bar from blocking the content of the container */}
        <Toolbar />
        
        <Container sx={{ mt: 4, mb: 4 }} maxWidth={false}>
          <div id="dashboard-content">
            <Outlet />
          </div>
          <Copyright sx={{ pt: 4 }} />
        </Container>
      </Box>
    </Box>
  );
}